<div class='PreviewContent'>
  <div class='PreviewContent-header flex flex-row'>
    <div class='Breadcrumbs'>
      <div class='Breadcrumbs-items'>
        <a [routerLink]="['/campaigns']">
          <mat-icon class='Breadcrumbs-icon back'>keyboard_backspace</mat-icon>
        </a>
        <a [routerLink]="['/campaigns']" class='Breadcrumbs-item first'>Campaigns</a>
      </div>
    </div>
  </div>
  <div class='PreviewContent-info mt-1 mt-sm-3 p-0 p-sm-5 d-flex flex-column'>
    <div class='PreviewContent-form'>
      <mat-horizontal-stepper #stepper *ngIf='dataReady' [selectedIndex]='selectedIndex'>
        <ng-template #noSign>
          <div class='alert alert-warning'>
            <p>There is no signature text added for that template. The system will append your default profile signature
              for that email.</p>
          </div>
        </ng-template>
        <mat-step *ngFor='let item of templates; let index = index' [stepControl]='getGroup(item.id)'>
          <form [formGroup]='getGroup(item.id)'>
            <ng-template matStepLabel>
              <span class='d-none d-sm-block'>{{ item.content_template }}</span>
            </ng-template>

            <h2 class='title__page'>Preview Content  {{ item.content_template }}</h2>
            <div *ngIf='index == 0' class='content'>
              <p><b>Subject Line: {{ item.subject }}</b></p>
              <app-html-viewer [html]='item.greeting'></app-html-viewer>
              <app-html-viewer [html]='item.content_attention'></app-html-viewer>
              <app-html-viewer [html]='item.first_benefit'></app-html-viewer>
              <app-html-viewer [html]='item.second_benefit'></app-html-viewer>
              <app-html-viewer [html]='item.third_benefit'></app-html-viewer>
              <app-html-viewer [html]='item.content_closing'></app-html-viewer>
              <hr>
              <app-html-viewer *ngIf='item.content_sign; else noSign' [html]='item.content_sign'></app-html-viewer>
              <app-html-viewer [html]='item.content_details'></app-html-viewer>
            </div>

            <div *ngIf='index == 1' class='content'>
              <p><b>Subject Line: {{ item.subject }}</b></p>
              <app-html-viewer [html]='item.greeting'></app-html-viewer>
              <app-html-viewer [html]='item.content_opening'></app-html-viewer>
              <app-html-viewer [html]='item.second_benefit'></app-html-viewer>
              <app-html-viewer [html]='item.content_attention'></app-html-viewer>
              <app-html-viewer [html]='item.first_benefit'></app-html-viewer>
              <app-html-viewer [html]='item.third_benefit'></app-html-viewer>
              <app-html-viewer [html]='item.content_closing'></app-html-viewer>
              <hr>
              <app-html-viewer *ngIf='item.content_sign; else noSign' [html]='item.content_sign'></app-html-viewer>
              <app-html-viewer [html]='item.content_details'></app-html-viewer>
            </div>

            <div *ngIf='index == 2' class='content'>
              <p><b>Subject Line: {{ item.subject }}</b></p>
              <app-html-viewer [html]='item.greeting'></app-html-viewer>
              <app-html-viewer [html]='item.content_opening'></app-html-viewer>
              <app-html-viewer [html]='item.first_benefit'></app-html-viewer>
              <app-html-viewer [html]='item.second_benefit'></app-html-viewer>
              <app-html-viewer [html]='item.third_benefit'></app-html-viewer>
              <app-html-viewer [html]='item.content_closing'></app-html-viewer>
              <hr>
              <app-html-viewer *ngIf='item.content_sign; else noSign' [html]='item.content_sign'></app-html-viewer>
              <app-html-viewer [html]='item.content_details'></app-html-viewer>
            </div>

            <div *ngIf='index == 3' class='content'>
              <p><b>Subject Line: {{ item.subject }}</b></p>
              <app-html-viewer [html]='item.greeting'></app-html-viewer>
              <app-html-viewer [html]='item.content_opening'></app-html-viewer>
              <app-html-viewer [html]='item.first_benefit'></app-html-viewer>
              <app-html-viewer [html]='item.content_attention'></app-html-viewer>
              <app-html-viewer [html]='item.third_benefit'></app-html-viewer>
              <app-html-viewer [html]='item.content_closing'></app-html-viewer>
              <hr>
              <app-html-viewer *ngIf='item.content_sign; else noSign' [html]='item.content_sign'></app-html-viewer>
              <app-html-viewer [html]='item.content_details'></app-html-viewer>
            </div>

            <div class='d-flex flex-row w-100'>
              <ng-container *ngIf='(index < templates.length-1)'>
                <app-button (click)='editTemplate(item.content_id,index)' [color]="'orange'" [size]="'normal'"
                            [style]="'filled'"
                            [text]="'Edit'"></app-button>
                <app-button (click)='stepperNext()' [size]="'normal'" [text]="'Next'" class='ms-3'
                            color='blue'></app-button>
              </ng-container>
              <ng-container *ngIf='(index == templates.length-1)'>
                <app-button (click)='editTemplate(item.content_id,index)' [color]="'orange'" [size]="'normal'"
                            [style]="'filled'"
                            [text]="'Edit'"></app-button>
                <app-button (click)='openFinishDialog()' [color]="'blue'" [size]="'normal'" [text]="'Finish'"
                            class='ms-3'></app-button>
              </ng-container>
            </div>
          </form>
        </mat-step>
      </mat-horizontal-stepper>

    </div>
  </div>
</div>
